package com.bikompanion.ui.models

/** What one attempt at a network came to. Null elsewhere means there was nothing to attempt. */
internal enum class LoadOutcome { Fresh, Stale, RateLimited }
